import './BusinessAssessment.css';
import 'react-loading-skeleton/dist/skeleton.css';

import { useEffect, useState } from 'react';

import AssessmentResults from '../AssessmentResults';
import { Button } from '@/components/atoms';
import { FullscreenOverlay } from '@/components/molecules'
import { HELPERS } from '@/utils';
import PATH from '@/routes/path';
import ReactPixel from 'react-facebook-pixel';
import { SERVICE_AI_ASSESSMENT } from '@/services/aiService';
import Skeleton from 'react-loading-skeleton';
import { notify } from 'react-notify-toast';
import { sendCustomTag } from '@/utils/clarity-tags';
import { useHistory } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const SuccessImage = '/images/success-subscribe.webp';







const currentImg = '/images/quiz/curent.webp';
const problemImg = '/images/quiz/problem.webp';
const skillImg = '/images/quiz/skill.webp';
const learnImg = '/images/quiz/learn.webp';

const ASSESSMENT_STEPS = {
  WELCOME: 0,
  PERSONAL_INTRO: 0.5,
  QUESTIONS_START: 1,
  LOGIN_PROMPT: 997,
  REGISTRATION_FORM: 998,
  RESULTS: 999,
  LOADING: 'loading'
};


const ProgressIndicator = ({ currentStep, totalSteps }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i);

  return (
    <div className="flex justify-center items-center my-3 md:my-8 w-full gap-2 px-4">
      {steps.map((stepIndex) => {
        const stepNumber = stepIndex + 1;
        let barClass = 'bg-gray-300';
        if (stepNumber < currentStep) {
          barClass = 'bg-[#029350]'; // Completed - Green
        } else if (stepNumber === currentStep) {
          barClass = 'bg-[#E8B931]'; // Current - Yellow
        }
        return (
          <div
            key={stepIndex}
            className={`h-2 flex-1 rounded-full ${barClass} transition-colors duration-300`}
          ></div>
        );
      })}
    </div>
  );
};

const PersonalIntroStep = ({ onNext, onBack, isLoading, userInfo, setUserInfo }) => {
  const { t } = useTranslation();
  const [name, setName] = useState(userInfo?.name || '');
  const [currentIntroStep, setCurrentIntroStep] = useState(1);

  const handleNext = () => {
    if (currentIntroStep === 1 && name.trim()) {
      // Track name submission
      const utmParams = HELPERS.getUTMParameters();
      
      HELPERS.sendEventGA('guest_name_submitted', {
        page_source: 'Personal Introduction',
        user_type: 'guest',
        name_length: name.trim().length
      });

      ReactPixel.track('Lead', {
        content_name: 'Guest Name Collection',
        status: 'name_submitted'
      });

      sendCustomTag('guest_intro', 'name_submitted');

      setUserInfo({ ...userInfo, name: name.trim() });
      setCurrentIntroStep(2);
    } else if (currentIntroStep === 2) {
      // Track progression to quiz
      const utmParams = HELPERS.getUTMParameters();
      
      HELPERS.sendEventGA('guest_intro_completed', {
        page_source: 'Personal Introduction',
        user_type: 'guest',
        progression: 'to_quiz'
      });

      ReactPixel.track('Lead', {
        content_name: 'Guest Introduction Complete',
        status: 'ready_for_quiz'
      });

      sendCustomTag('guest_intro', 'completed');

      onNext();
    }
  };

  const handleBack = () => {
    if (currentIntroStep === 2) {
      setCurrentIntroStep(1);
    } else {
      onBack();
    }
  };

  if (currentIntroStep === 1) {
    return (
      <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
          Hai! Salam kenal
        </h1>

        <p className="text-md text-gray-600 mb-2 max-w-md">
          Kami mau bantu kamu nemuin program belajar yang
          <span className="text-purple-600 font-semibold"> cocok banget</span> buat bisnis kamu
        </p>

        <p className="text-sm text-gray-500 mb-6">
          Pertama, boleh kenalan dulu?
        </p>


        <div className="w-full max-w-md mb-8">
          <input
            type="text"
            placeholder="Nama kamu siapa?"
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none transition-colors"
            maxLength={50}
            onKeyPress={(e) => {
              if (e.key === 'Enter' && name.trim()) {
                handleNext();
              }
            }}
          />
        </div>

        <div className="flex items-center gap-4 mb-8">
          <div className="flex -space-x-2">
            <div className="w-8 h-8 bg-purple-200 rounded-full border-2 border-white flex items-center justify-center">
              <span className="text-xs font-semibold text-purple-700">A</span>
            </div>
            <div className="w-8 h-8 bg-blue-200 rounded-full border-2 border-white flex items-center justify-center">
              <span className="text-xs font-semibold text-blue-700">R</span>
            </div>
            <div className="w-8 h-8 bg-green-200 rounded-full border-2 border-white flex items-center justify-center">
              <span className="text-xs font-semibold text-green-700">S</span>
            </div>
          </div>
          <p className="text-sm text-gray-600">
            <strong>500 owner bisnis</strong> sudah ikut hari ini
          </p>
        </div>


        <div className="quiz-buttons-container">
          <Button
            onClick={handleNext}
            variant={Button.VARIANTS.SECONDARY}
            size={Button.SIZES.MEDIUM}
            disabled={!name.trim() || isLoading}
            type="button"
          >
            Lanjut
          </Button>
        </div>
      </div>
    );
  }

  return (
    <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
        Senang kenalan sama kamu, {name}!
      </h1>
      <p className="text-md text-gray-600 mb-2">
        Sekarang giliranmu cerita
      </p>
      <p className="text-sm text-gray-500 mb-8">
        Cuma 4 pertanyaan singkat kok, gak sampai 2 menit
      </p>

      <img src={SuccessImage} alt="Mari Mulai Assessment" className="w-48 md:w-64 mb-8" />

      <div className="quiz-buttons-container">
        <Button
          onClick={handleBack}
          variant={Button.VARIANTS.GRAY_OUTLINE}
          size={Button.SIZES.MEDIUM}
          type="button"
        >
          Kembali
        </Button>
        <Button
          onClick={handleNext}
          variant={Button.VARIANTS.SECONDARY}
          size={Button.SIZES.MEDIUM}
          disabled={isLoading}
          type="button"
        >
          {isLoading ? 'Menyiapkan...' : 'Yuk, Mulai!'}
        </Button>
      </div>
    </div>
  );
};

const WelcomeStep = ({ onNext, isLoading, hasMonthlyAssessment, latestAssessment, onViewResults }) => {
  const { t } = useTranslation();

  if (hasMonthlyAssessment && latestAssessment) {
    return (
      <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
        <h1 className="text-2xl md:text-4xl font-bold text-purple-600 mb-4">Quiz Bulan Ini</h1>
        <p className="text-md md:text-lg text-gray-600 mb-4">
          Anda sudah melakukan quiz bulan ini pada{' '}
          {new Date(latestAssessment.completed_at).toLocaleDateString('id-ID', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
          })}
        </p>
        <p className="text-sm text-gray-500 mb-8">
          Quiz berikutnya dapat dilakukan bulan depan untuk mendapatkan rekomendasi yang lebih update.
        </p>

        <img src={SuccessImage} alt="Quiz Completed" className="w-48 md:w-64 mb-8" />

        <div className="flex gap-4">
          <Button
            onClick={onViewResults}
            variant={Button.VARIANTS.SECONDARY}
            size={Button.SIZES.LARGE}
            disabled={isLoading}
            type="button"
          >
            Lihat Hasil Quiz
          </Button>

          {/* Remove personal learning path redirect - now handled by onViewResults */}
        </div>
      </div>
    );
  }

  return (
    <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
      <h1 className="text-2xl md:text-4xl font-bold text-purple-600 mb-4">Program Belajar Sesuai Kebutuhanmu</h1>
      <p className="text-md md:text-lg text-gray-600 mb-8">
        Jawab beberapa pertanyaan yang kami berikan untuk mendapatkan program belajar yang sesuai kebutuhanmu.
      </p>

      <img src={SuccessImage} alt="Program Belajar Sesuai Kebutuhanmu" className="w-48 md:w-64 mb-8" />

      <Button onClick={onNext} variant={Button.VARIANTS.SECONDARY} size={Button.SIZES.LARGE} disabled={isLoading} type="button">
        {isLoading ? 'Mempersiapkan Quiz...' : 'Buat Quiz Baru'}
      </Button>
    </div>
  );
};

const QuestionStep = ({
  category,
  onNext,
  onBack,
  answers,
  setAnswers,
  currentCategoryIndex,
  totalCategories,
  isLoading,
  isSubmitting,
}) => {
  const { t } = useTranslation();
  const [showEssay, setShowEssay] = useState(false);
  const [essayText, setEssayText] = useState('');

  // Initialize state from saved answers when component mounts or category changes
  useEffect(() => {
    const savedAnswer = answers[category.id];
    if (savedAnswer) {
      setShowEssay(savedAnswer.showEssay || false);
      setEssayText(savedAnswer.essay || '');
    } else {
      setShowEssay(false);
      setEssayText('');
    }
  }, [category.id, answers]);

  const handleCheckboxChange = (questionId) => {
    const currentAnswers = answers[category.id]?.checkboxes || [];
    const newAnswers = currentAnswers.includes(questionId)
      ? currentAnswers.filter((id) => id !== questionId)
      : [...currentAnswers, questionId];

    setAnswers({
      ...answers,
      [category.id]: {
        ...answers[category.id],
        checkboxes: newAnswers,
        essay: essayText,
        showEssay: showEssay,
      },
    });
  };

  const handleEssayToggle = () => {
    const newShowEssay = !showEssay;
    setShowEssay(newShowEssay);

    // Save the essay toggle state
    setAnswers({
      ...answers,
      [category.id]: {
        ...answers[category.id],
        showEssay: newShowEssay,
        essay: newShowEssay ? essayText : '',
      },
    });
  };

  const handleEssayChange = (e) => {
    const text = e.target.value;
    setEssayText(text);

    setAnswers({
      ...answers,
      [category.id]: {
        ...answers[category.id],
        essay: text,
        showEssay: showEssay,
      },
    });
  };

  const charCount = essayText.trim().length;
  const hasCheckboxAnswers = (answers[category.id]?.checkboxes || []).length > 0;
  const hasEssayAnswer = showEssay && essayText.trim().length > 0;
  // If essay is shown (Lainnya... checked), essay text becomes required
  const isEssayRequired = showEssay;
  const isNextDisabled = !hasCheckboxAnswers && !hasEssayAnswer && !isEssayRequired;
  // More specific validation: if Lainnya checked, essay must be filled
  const isFormValid = hasCheckboxAnswers || (showEssay && essayText.trim().length > 0);
  const isLastQuestion = currentCategoryIndex + 1 === totalCategories;

  return (
    <div className="p-1 md:p-8 flex flex-col min-h-[500px]">
      <div className="flex-grow">
        {/* Display illustration if exists and position is 'top' */}
        {category.illustration && category.illustration.position === 'top' && (
          <div className="mb-6 text-center">
            <img
              src={category.illustration.src}
              alt={category.illustration.alt}
              loading="lazy"
              decoding="async"
              className="max-w-xs mx-auto h-32 md:h-40 object-contain"
              style={{ aspectRatio: '1/1' }}
            />
          </div>
        )}

        <h2 className="text-xl md:text-2xl font-bold text-purple-600 mb-2">{category.title}</h2>
        <p className="text-gray-500 mb-6">{category.description}</p>

        <div className="space-y-3">
          {category.questions.map((q, index) => (
            <label
              key={q.id}
              className="flex items-start p-4 border rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
            >
              <input
                type="checkbox"
                className="h-5 w-5 text-purple-600 border-gray-300 rounded-none focus:ring-purple-500 mt-0.5"
                style={{ appearance: 'auto', WebkitAppearance: 'checkbox' }}
                checked={(answers[category.id]?.checkboxes || []).includes(q.id)}
                onChange={() => handleCheckboxChange(q.id)}
              />
              <span className="ml-3 text-gray-700">{q.text}</span>
            </label>
          ))}
          {category.essay && (
            <label className="flex items-start p-4 border-2 border-gray-200 rounded-lg hover:border-purple-400 cursor-pointer transition-colors">
              <input
                type="checkbox"
                className="h-5 w-5 text-purple-600 border-gray-300 rounded-none focus:ring-purple-500 mt-0.5"
                style={{ appearance: 'auto', WebkitAppearance: 'checkbox' }}
                checked={showEssay}
                onChange={handleEssayToggle}
              />
              <span className="ml-3 text-gray-700">Lainnya...</span>
            </label>
          )}
        </div>

        {showEssay && category.essay && (
          <div className="mt-6 animate-fadeIn">
            <p className="text-gray-600 font-medium mb-2">{category.essay.prompt}</p>
            <textarea
              className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 resize-none"
              rows="4"
              placeholder="Tulis jawaban Anda di sini..."
              value={essayText}
              onChange={handleEssayChange}
              maxLength={200}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                  e.preventDefault();
                  if (isFormValid) {
                    onNext();
                  }
                }
              }}
            />
            <p
              className={`text-sm mt-1 text-right ${charCount > 200 ? 'text-red-500' : charCount === 0 && showEssay ? 'text-red-500' : 'text-gray-500'}`}
            >
              {charCount}/200 karakter {showEssay && charCount === 0 ? '(wajib diisi)' : ''}
            </p>
          </div>
        )}
      </div>

      <div className="quiz-nav-buttons">
        <Button
          onClick={onBack}
          variant={Button.VARIANTS.GRAY_OUTLINE}
          size={Button.SIZES.MEDIUM}
          disabled={isLoading || isSubmitting}
          type="button"
        >
          Kembali
        </Button>
        <Button
          onClick={onNext}
          variant={Button.VARIANTS.SECONDARY}
          size={Button.SIZES.MEDIUM}
          disabled={!isFormValid || isLoading || isSubmitting}
          type="button"
        >
          {isSubmitting
            ? 'Menganalisis Bisnismu...'
            : isLoading
              ? 'Memuat Pertanyaan...'
              : isLastQuestion
                ? 'Lihat Rekomendasi Bisnis! ✨'
                : 'Selanjutnya'}
        </Button>
      </div>
    </div>
  );
};

const getStaticQuestionsForGuest = () => {
  return {
    assessmentId: `guest-${Date.now()}`,
    generatedAt: new Date().toISOString(),
    framework: 'business_categories',
    categories: [
      {
        id: 'goal_target',
        title: 'Impian Bisnismu',
        description: 'Mana yang paling kamu inginkan? (pilih semua yang sesuai)',
        order: 1,
        illustration: {
          src: learnImg, // Gambar learn untuk impian/goal
          alt: 'Ilustrasi Impian Bisnis',
          position: 'top' // Posisi ilustrasi: 'top', 'bottom', atau 'side'
        },
        questions: [
          {
            id: 'revenue_2x',
            text: 'Omzet naik 2x lipat dalam setahun',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['revenue', 'growth'] },
          },
          {
            id: 'expand_new_market',
            text: 'Buka cabang atau jangkau kota lain',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['expansion', 'market'] },
          },
          {
            id: 'launch_new_product',
            text: 'Launching produk/jasa baru yang laku',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['product', 'innovation'] },
          },
          {
            id: 'build_solid_team',
            text: 'Punya tim yang solid dan profesional',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['team', 'organization'] },
          },
        ],
        essay: {
          prompt: 'Ada impian lain untuk bisnismu? Ceritakan di sini (opsional)',
          required: false,
        },
      },
      {
        id: 'current_situation',
        title: 'Kondisi Bisnismu Sekarang',
        description: 'Yang mana yang sudah kamu miliki?',
        order: 2,
        illustration: {
          src: currentImg, // Gambar current untuk kondisi saat ini
          alt: 'Ilustrasi Kondisi Bisnis',
          position: 'top'
        },
        questions: [
          {
            id: 'has_online_presence',
            text: 'Sudah aktif di sosmed & punya toko online',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['marketing', 'digital'] },
          },
          {
            id: 'has_financial_record',
            text: 'Sudah mencatat keuangan dengan rapi',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['finance', 'management'] },
          },
          {
            id: 'has_team',
            text: 'Sudah punya tim/karyawan',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['leadership', 'team'] },
          },
          {
            id: 'has_regular_customers',
            text: 'Punya pelanggan tetap/loyal',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['customer', 'retention'] },
          },
        ],
        essay: {
          prompt: 'Hal lain yang sudah kamu miliki? Jelaskan di sini (opsional)',
          required: false,
        },
      },
      {
        id: 'main_challenges',
        title: 'Tantangan Terbesarmu',
        description: 'Apa yang bikin kamu pusing sekarang?',
        order: 3,
        illustration: {
          src: problemImg, // Gambar problem untuk tantangan
          alt: 'Ilustrasi Tantangan Bisnis',
          position: 'top'
        },
        questions: [
          {
            id: 'low_sales',
            text: 'Penjualan turun/sepi orderan',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['customer', 'acquisition'] },
          },
          {
            id: 'cash_flow_tight',
            text: 'Modal terbatas/cash flow seret',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['finance', 'cashflow'] },
          },
          {
            id: 'high_competition',
            text: 'Kompetitor makin banyak & agresif',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['competition', 'market'] },
          },
          {
            id: 'no_time',
            text: 'Gak ada waktu urus semua sendiri',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['management', 'productivity'] },
          },
        ],
        essay: {
          prompt: 'Tantangan lain yang kamu hadapi? Ceritakan di sini (opsional)',
          required: false,
        },
      },
      {
        id: 'skill_needs',
        title: 'Yang Ingin Kamu Pelajari',
        description: 'Skill apa yang paling kamu butuhkan sekarang?',
        order: 4,
        illustration: {
          src: skillImg, // Gambar skill untuk pembelajaran
          alt: 'Ilustrasi Skill yang Dibutuhkan',
          position: 'top'
        },
        questions: [
          {
            id: 'digital_marketing',
            text: 'Cara jualan online yang menghasilkan',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['marketing', 'digital', 'learning'] },
          },
          {
            id: 'financial_management',
            text: 'Atur keuangan bisnis dengan benar',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['finance', 'planning', 'learning'] },
          },
          {
            id: 'team_management',
            text: 'Memimpin tim & delegasi tugas',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['leadership', 'management', 'learning'] },
          },
          {
            id: 'product_innovation',
            text: 'Bikin produk yang dicari customer',
            type: 'checkbox',
            metadata: { weight: 1, tags: ['product', 'innovation', 'learning'] },
          },
        ],
        essay: {
          prompt: 'Skill lain yang ingin kamu pelajari? Jelaskan di sini (opsional)',
          required: false,
        },
      },
    ],
  };
};
const LoginPromptStep = ({ onLogin, onBack }) => {
  const { t } = useTranslation();

  return (
    <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px] max-w-lg mx-auto">
      <div className="mb-8">
        <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
        </div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
          Akun Sudah Terdaftar! 🎉
        </h1>
        <p className="text-lg text-gray-600 mb-4">
          Kamu sudah punya akun dan sudah mengikuti quiz bulan ini.
        </p>
        <p className="text-sm text-gray-500 mb-8">
          Silakan login untuk melihat hasil quiz dan rekomendasi bisnismu.
        </p>
      </div>

      <div className="quiz-buttons-container">
        <Button
          onClick={onBack}
          variant={Button.VARIANTS.GRAY_OUTLINE}
          size={Button.SIZES.MEDIUM}
          type="button"
        >
          Kembali
        </Button>
        <Button
          onClick={onLogin}
          variant={Button.VARIANTS.SECONDARY}
          size={Button.SIZES.MEDIUM}
          type="button"
        >
          Login Sekarang 🚀
        </Button>
      </div>
    </div>
  );
};

const RegistrationFormStep = ({ onSubmit, onBack, isLoading, userInfo, setUserInfo, apiError: propApiError, onClearError }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: userInfo?.email || '',
    phone: userInfo?.phone || '',
    password: '',
    confirmPassword: '',
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');

  useEffect(() => {
    if (propApiError) {
      setApiError(propApiError);
    }
  }, [propApiError]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.email.trim()) {
      newErrors.email = 'Email wajib diisi';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Format email tidak valid';
    }

    if (!formData.phone.trim()) {
      newErrors.phone = 'Nomor handphone wajib diisi';
    } else if (!/^[0-9]{8,15}$/.test(formData.phone.replace(/[^0-9]/g, ''))) {
      newErrors.phone = 'Nomor handphone tidak valid';
    }

    if (!formData.password.trim()) {
      newErrors.password = 'Password wajib diisi';
    } else if (formData.password.length < 8) {
      newErrors.password = 'Password minimal 8 karakter';
    }

    if (formData.password !== formData.confirmPassword) {
      newErrors.confirmPassword = 'Konfirmasi password tidak cocok';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      // Track registration form submission
      const utmParams = HELPERS.getUTMParameters();
      
      HELPERS.sendEventGA('guest_registration_submitted', {
        page_source: 'Registration Form',
        user_type: 'guest',
        form_step: 'final_submission',
        has_phone: !!formData.phone.trim(),
        ...utmParams
      });

      ReactPixel.track('CompleteRegistration', {
        content_name: 'Guest Registration Form',
        status: 'form_submitted',
        ...utmParams
      });

      sendCustomTag('guest_registration', 'form_submitted');

      const updatedUserInfo = {
        ...userInfo,
        email: formData.email.trim(),
        phone: formData.phone.replace(/[^0-9]/g, '').replace(/^0/, ''), // Remove leading 0
        password: formData.password,
      };
      setUserInfo(updatedUserInfo);
      onSubmit(updatedUserInfo);
    }
  };

  const handleChange = (field) => (e) => {
    setFormData({ ...formData, [field]: e.target.value });
    if (errors[field]) {
      setErrors({ ...errors, [field]: '' });
    }
    if (apiError) {
      setApiError('');
      if (onClearError) {
        onClearError();
      }
    }
  };

  return (
    <div className="p-8 max-w-lg mx-auto">
      <div className="text-center mb-8">
        <h2 className="text-2xl md:text-3xl font-bold text-purple-600 mb-4">
          Hampir Selesai! 🎉
        </h2>
        <p className="text-gray-600 mb-2">
          Quiz Anda sudah selesai, {userInfo?.name || 'teman'}!
        </p>
        <p className="text-sm text-gray-500">
          <span className="font-medium text-purple-600">Hasil akan muncul di akun Anda.</span><br />
          Harap membuat akun dahulu untuk melihat rekomendasi personal.
        </p>
      </div>

      {apiError && (
        <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
          <p className="text-red-700 text-sm">{apiError}</p>
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Email *
          </label>
          <input
            type="email"
            value={formData.email}
            onChange={handleChange('email')}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${errors.email ? 'border-red-500' : 'border-gray-300'}`}
            placeholder="email@contoh.com"
          />
          {errors.email && <p className="text-red-500 text-sm mt-1">{errors.email}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Nomor Handphone *
          </label>
          <div className="flex">
            <span className="inline-flex items-center px-3 bg-gray-50 border border-r-0 border-gray-300 rounded-l-lg text-gray-500">
              +62
            </span>
            <input
              type="tel"
              value={formData.phone}
              onChange={handleChange('phone')}
              className={`w-full px-4 py-3 border rounded-r-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none ${errors.phone ? 'border-red-500' : 'border-gray-300'}`}
              placeholder="81234567890"
            />
          </div>
          {errors.phone && <p className="text-red-500 text-sm mt-1">{errors.phone}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Password *
          </label>
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              value={formData.password}
              onChange={handleChange('password')}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none pr-12 ${errors.password ? 'border-red-500' : 'border-gray-300'}`}
              placeholder="Minimal 8 karakter"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <Icon 
                icon={showPassword ? "material-symbols:visibility-off-outline" : "material-symbols:visibility-outline"} 
                className="w-5 h-5" 
              />
            </button>
          </div>
          {errors.password && <p className="text-red-500 text-sm mt-1">{errors.password}</p>}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Konfirmasi Password *
          </label>
          <div className="relative">
            <input
              type={showConfirmPassword ? 'text' : 'password'}
              value={formData.confirmPassword}
              onChange={handleChange('confirmPassword')}
              className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-purple-500 outline-none pr-12 ${errors.confirmPassword ? 'border-red-500' : 'border-gray-300'}`}
              placeholder="Ulangi password"
            />
            <button
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
            >
              <Icon 
                icon={showConfirmPassword ? "material-symbols:visibility-off-outline" : "material-symbols:visibility-outline"} 
                className="w-5 h-5" 
              />
            </button>
          </div>
          {errors.confirmPassword && <p className="text-red-500 text-sm mt-1">{errors.confirmPassword}</p>}
        </div>

        <div className="quiz-buttons-container pt-4">
          <Button
            onClick={onBack}
            variant={Button.VARIANTS.GRAY_OUTLINE}
            size={Button.SIZES.MEDIUM}
            type="button"
            disabled={isLoading}
          >
            Kembali
          </Button>
          <Button
            type="submit"
            variant={Button.VARIANTS.SECONDARY}
            size={Button.SIZES.MEDIUM}
            disabled={isLoading}
          >
            {isLoading ? 'Sedang menyiapkan rekomendasi...' : 'Lihat Rekomendasi Bisnis Kamu! 🚀'}
          </Button>
        </div>
      </form>
    </div>
  );
};

const LoadingStep = ({ message = 'Memproses...' }) => {
  return (
    <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
      <div className="flex flex-col items-center gap-6 w-full max-w-md">
        {/* Main Loading Animation */}
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-purple-100">
          <Skeleton circle width={80} height={80} />
        </div>

        {/* Title Skeleton */}
        <div className="w-full">
          <Skeleton height={28} width="80%" className="mb-2" />
          <Skeleton height={20} width="60%" />
        </div>

        {/* Message */}
        <p className="text-gray-600 text-sm">{message}</p>

        {/* Progress Steps Skeleton */}
        <div className="flex items-center gap-2 w-full">
          {[1, 2, 3, 4].map((index) => (
            <Skeleton key={index} height={12} className="flex-1 rounded-full" />
          ))}
        </div>

        {/* Action Buttons Skeleton */}
        <div className="flex gap-3 w-full">
          <Skeleton height={44} className="flex-1 rounded-full" />
          <Skeleton height={44} className="flex-1 rounded-full" />
        </div>
      </div>
    </div>
  );
};


const BusinessAssessment = ({
  onComplete = null,
  userInfo: externalUserInfo = null,
  showResults = false,
  resultsData = null
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const { loggedIn } = useSelector((state) => state.auth);

  const [currentStep, setCurrentStep] = useState(loggedIn ? ASSESSMENT_STEPS.WELCOME : ASSESSMENT_STEPS.PERSONAL_INTRO);
  const [answers, setAnswers] = useState({});
  const [assessmentData, setAssessmentData] = useState(null);
  const [assessmentId, setAssessmentId] = useState(null);
  const [selectedModel, setSelectedModel] = useState('default');
  const [recommendations, setRecommendations] = useState(null);
  const [startTime, setStartTime] = useState(null);
  const [userInfo, setUserInfo] = useState(externalUserInfo || {});
  const [isLoading, setIsLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isInitializing, setIsInitializing] = useState(true);
  const [isGeneratingNew, setIsGeneratingNew] = useState(false);
  const [registrationError, setRegistrationError] = useState('');
  const [latestAssessment, setLatestAssessment] = useState(null);
  const [hasMonthlyAssessment, setHasMonthlyAssessment] = useState(false);
  const [canCreateNew, setCanCreateNew] = useState(false);
  const [existingFeedback, setExistingFeedback] = useState(null);
  const [error, setError] = useState(null);
  const isGuest = !loggedIn;

  const [overlayEnabled, setOverlayEnabled] = useState(() => {
    return isGuest && sessionStorage.getItem('quizOverlayDisabled') !== '1';
  });

  useEffect(() => {
    if (!isGuest) {
      sessionStorage.removeItem('quizOverlayDisabled');
      setOverlayEnabled(false);
    } else {
      setOverlayEnabled(sessionStorage.getItem('quizOverlayDisabled') !== '1');
    }
  }, [isGuest]);

  const dismissOverlay = () => {
    setOverlayEnabled(false);
    try { sessionStorage.setItem('quizOverlayDisabled', '1'); } catch { }
    HELPERS.sendEventGA('guest_overlay_dismissed', {
      page_source: 'Business Assessment',
    });
  };

  const totalQuestionSteps = assessmentData?.categories?.length || 0;
  const isInQuestionPhase = currentStep >= ASSESSMENT_STEPS.QUESTIONS_START && currentStep <= totalQuestionSteps;
  const shouldShowResults = currentStep === ASSESSMENT_STEPS.RESULTS;

  // Helper functions
  const resetAssessmentState = () => {
    setAnswers({});
    setCurrentStep(ASSESSMENT_STEPS.WELCOME);
    setAssessmentData(null);
    setAssessmentId(null);
    setSelectedModel('default');
    setRecommendations(null);
    setLatestAssessment(null);
    setHasMonthlyAssessment(false);
    setError(null);
    localStorage.removeItem('currentAssessmentId');
    localStorage.removeItem('selectedAiModel');
  };

  const handleError = (error, userMessage = 'Terjadi kesalahan tidak terduga') => {
    console.error('BusinessAssessment Error:', error);
    setError(error.message || userMessage);
    notify.show(userMessage, 'error');
    setIsLoading(false);
    setIsSubmitting(false);
  };

  const handleFeedbackSubmitted = () => {
    setCanCreateNew(false);
    // Refresh data after feedback is submitted
    refetchLatestAssessment();
  };

  const handleModelSelect = (model) => {
    setSelectedModel(model);
  };

  // Generate AI questions when user clicks "Mulai Assessment"
  const handleGenerateQuestions = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    setIsLoading(true);
    setStartTime(Date.now());

    // Track assessment started
    const utmParams = HELPERS.getUTMParameters();
    
    HELPERS.sendEventGA('assessment_started', {
      page_source: 'Business Assessment',
      assessment_step: 'initial',
      ai_model: loggedIn ? selectedModel : 'static_questions',
      user_status: loggedIn ? 'logged_in' : 'guest',
      timestamp: new Date().toISOString()
    });

    ReactPixel.track('Lead', {
      content_name: 'Business Assessment Started',
      status: 'assessment_started'
    });

    try {
      let responseData;

      if (loggedIn) {
        // For logged in users, use AI-generated questions
        const userProfile = {
          // Add user profile data if available
        };

        const response = await SERVICE_AI_ASSESSMENT.generateAssessmentQuestions(userProfile);
        responseData = response.data || response.payload;

        if (!response.success || !responseData) {
          const errorMessage = response.error === 'timeout'
            ? 'Gagal memuat pertanyaan AI - timeout. Silakan coba lagi.'
            : 'Gagal memuat pertanyaan AI. Silakan coba lagi.';
          throw new Error(errorMessage);
        }
      } else {
        // For guest users, use static questions
        responseData = getStaticQuestionsForGuest();

        // Track static questions loaded for guest
        const utmParams = HELPERS.getUTMParameters();
        
        HELPERS.sendEventGA('guest_static_questions_loaded', {
          page_source: 'Business Assessment',
          user_type: 'guest',
          question_type: 'static',
          categories_count: responseData.categories.length
        });

        ReactPixel.track('ViewContent', {
          content_name: 'Guest Static Assessment Questions',
          content_category: 'assessment',
          content_type: 'static_questions'
        });

        sendCustomTag('guest_assessment', 'static_questions_loaded');
      }

      setAssessmentData(responseData);
      setAssessmentId(responseData.assessmentId);
      setCurrentStep(ASSESSMENT_STEPS.QUESTIONS_START);

      // Auto-save assessment ID and selected model (only for logged in users)
      if (loggedIn) {
        localStorage.setItem('currentAssessmentId', responseData.assessmentId);
        localStorage.setItem('selectedAiModel', selectedModel);
      }

    } catch (error) {
      handleError(error, 'Gagal memuat pertanyaan. Silakan coba lagi.');
    } finally {
      setIsLoading(false);
    }
  };

  // Submit answers and get recommendations
  const handleSubmitAssessment = async () => {
    setIsSubmitting(true);

    try {
      const timeSpent = startTime ? Math.floor((Date.now() - startTime) / 1000) : 0;
      const completionRate = Object.keys(answers).length / assessmentData.categories.length;

      if (!loggedIn) {
        // Track guest quiz completion before registration
        const utmParams = HELPERS.getUTMParameters();
        
        HELPERS.sendEventGA('guest_quiz_completed', {
          page_source: 'Business Assessment',
          user_type: 'guest',
          question_type: 'static',
          categories_answered: Object.keys(answers).length,
          completion_rate: Object.keys(answers).length / assessmentData.categories.length,
          time_spent_seconds: Math.floor((Date.now() - startTime) / 1000),
          ...utmParams
        });

        ReactPixel.track('Lead', {
          content_name: 'Guest Quiz Completed',
          status: 'ready_for_registration',
          ...utmParams
        });

        sendCustomTag('guest_assessment', 'quiz_completed');

        // For guest users, go to registration form step
        setCurrentStep(ASSESSMENT_STEPS.REGISTRATION_FORM);
        return;
      }

      const metadata = {
        timeSpent,
        completionRate,
        deviceInfo: {
          userAgent: navigator.userAgent,
          platform: navigator.platform,
        },
      };

      const response = await SERVICE_AI_ASSESSMENT.submitAssessmentAnswers(assessmentId, answers, metadata);

      // Handle both 'data' and 'payload' for backward compatibility
      const responseData = response.data || response.payload;

      if (response.success && responseData) {
        // Handle new nested structure where data is inside assessment object
        const assessmentData = responseData.assessment || responseData;

        // Validate essential data exists
        if (!assessmentData.recommendations || !Array.isArray(assessmentData.recommendations)) {
          throw new Error('Invalid recommendations data received from server');
        }

        // Map API response to expected format - include bundle_pricing
        const submissionData = {
          recommendations: assessmentData.recommendations || [],
          analysis: assessmentData.analysis || {},
          bundle: assessmentData.bundle || {},
          bundle_pricing: assessmentData.bundle_pricing || {},
          nextSteps: assessmentData.nextSteps || [],
          personal_learning_path: assessmentData.personal_learning_path || null,
          mentoring: assessmentData.mentoring || null,
        };

        setRecommendations(submissionData);
        setCurrentStep(ASSESSMENT_STEPS.RESULTS);

        // Update canCreateNew state - user cannot create new assessment after successful submission
        setCanCreateNew(false);

        // Call onComplete callback if provided (for journey integration)
        if (onComplete) {
          onComplete(submissionData);
        }

        // Track assessment completed
        const utmParams = HELPERS.getUTMParameters();
        
        HELPERS.sendEventGA('assessment_completed', {
          page_source: 'Business Assessment',
          assessment_id: assessmentId,
          completion_time: timeSpent,
          completion_rate: completionRate,
          recommendations_count: responseData?.recommendations?.length || 0,
          mentoring_available: responseData?.mentoring?.available || false,
          personal_learning_path_available: !!responseData?.personal_learning_path,
          total_value: responseData?.personal_learning_path?.pricing?.remaining_amount || 0
        });

        ReactPixel.track('CompleteRegistration', {
          content_name: 'Business Assessment Completed',
          status: 'assessment_completed',
          value: responseData?.personal_learning_path?.pricing?.remaining_amount || 0,
          currency: 'IDR'
        });

        // Clear saved assessment
        localStorage.removeItem('currentAssessmentId');
      } else {
        throw new Error('Failed to get recommendations');
      }
    } catch (error) {
      handleError(error, 'Gagal mengirim jawaban. Silakan coba lagi.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleNext = async (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    const isLastQuestion = currentStep === totalQuestionSteps;

    if (isLastQuestion) {
      await handleSubmitAssessment();
    } else {
      const nextStep = currentStep + 1;
      setCurrentStep(nextStep);

      // Auto-save progress (only for logged in users)
      if (loggedIn && assessmentId && currentStep >= ASSESSMENT_STEPS.QUESTIONS_START) {
        try {
          await SERVICE_AI_ASSESSMENT.saveAssessmentProgress(assessmentId, answers, nextStep);
        } catch (error) {
          console.error('Failed to save progress:', error);
        }
      }
    }
  };

  const handleBack = (e) => {
    e?.preventDefault();
    e?.stopPropagation();

    if (currentStep > ASSESSMENT_STEPS.WELCOME) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleStartOver = () => {
    resetAssessmentState();
  };

  const handleLoginRedirect = () => {
    // Track login redirect
    HELPERS.sendEventGA('guest_prompted_to_login', {
      page_source: 'Business Assessment',
      user_type: 'existing_user',
      reason: 'monthly_limit_exceeded',
    });

    ReactPixel.track('Lead', {
      content_name: 'Guest Login Redirect',
      status: 'existing_user_login_prompted',
    });

    // Redirect to login with return path
    history.push(`${PATH.AUTH_LOGIN}?redirect=/personal-learning-program`);
  };

  const handleViewResults = async () => {

    // Check if personal learning path exists
    const personalLearningPath = latestAssessment?.personal_learning_path;
    const learningPathUuid = personalLearningPath?.uuid;

    if (learningPathUuid) {

      // Track button click
      HELPERS.sendEventGA('view_learning_path_clicked', {
        page_source: 'Business Assessment Welcome',
        learning_path_id: personalLearningPath.id,
        learning_path_uuid: learningPathUuid,
        user_status: 'logged_in',
      });

      ReactPixel.track('ViewContent', {
        content_name: 'Personal Learning Path Redirect',
        content_category: 'learning_path',
        content_id: personalLearningPath.id,
      });

      // Redirect to personal learning path detail page using UUID
      history.push(`/personal-learning-program/${personalLearningPath.uuid}`);
    } else {

      // Fallback: Get UUID from latestAssessment object for assessment history
      const assessmentUuid = latestAssessment?.uuid || latestAssessment?.id || latestAssessment?.assessment_id;

      if (assessmentUuid) {
        // Track fallback button click
        HELPERS.sendEventGA('view_assessment_results_clicked', {
          page_source: 'Business Assessment Welcome',
          assessment_id: assessmentUuid,
          user_status: 'logged_in',
          fallback_reason: 'no_learning_path',
        });

        ReactPixel.track('ViewContent', {
          content_name: 'Assessment Results Redirect',
          content_category: 'assessment',
          content_id: assessmentUuid,
        });

        // Redirect to assessment history detail page  
        history.push(`${PATH.ASSESSMENT_HISTORY}/${assessmentUuid}`);
      } else {
        // Final fallback: go to assessment history page
        history.push(PATH.ASSESSMENT_HISTORY);
      }
    }
  };

  const handleGenerateNew = async () => {
    setIsGeneratingNew(true);

    try {
      resetAssessmentState();
      await handleGenerateQuestions();
    } catch (error) {
      handleError(error, 'Gagal memulai assessment baru. Silakan coba lagi.');
    } finally {
      setIsGeneratingNew(false);
    }
  };

  // Handle registration form submission for guest users
  const handleRegistrationSubmit = async (registrationData) => {
    setIsSubmitting(true);

    try {
      const timeSpent = startTime ? Math.floor((Date.now() - startTime) / 1000) : 0;
      const completionRate = Object.keys(answers).length / assessmentData.categories.length;

      // Convert answers to API format - per category structure
      const formattedAnswers = {};
      Object.keys(answers).forEach(categoryId => {
        const categoryAnswers = answers[categoryId];
        formattedAnswers[categoryId] = {
          checkboxes: categoryAnswers.checkboxes || [],
          essay: categoryAnswers.essay || ''
        };
      });

      // Submit assessment with registration - simplified payload
      const response = await SERVICE_AI_ASSESSMENT.submitAssessmentWithRegistration(
        registrationData,
        formattedAnswers
      );


      if (response.success) {
        const responseData = response.data || response.payload;

        // Track successful assessment with registration
        const utmParams = HELPERS.getUTMParameters();
        
        HELPERS.sendEventGA('assessment_with_registration_success', {
          page_source: 'Business Assessment',
          user_type: responseData.user_type,
          activation_required: responseData.activation_required,
          ...utmParams,
          conversion_source: utmParams.utm_source || 'organic'
        });

        ReactPixel.track('CompleteRegistration', {
          content_name: 'Assessment Auto Registration',
          method: 'integrated_flow',
          ...utmParams
        });

        // Check if activation is required
        if (responseData.activation_required) {
          // Show activation required message
          notify.show('Assessment berhasil diselesaikan. Silakan cek email untuk aktivasi akun dan melihat hasil assessment.', 'success', 8000);

          // Redirect to login after showing message
          setTimeout(() => {
            history.push(`${PATH.AUTH_LOGIN}?redirect=/personal-learning-program`);
          }, 2000);
        } else {
          // Update recommendations with API response
          if (responseData.assessment) {
            setRecommendations(responseData.assessment);
          }

          // Show results directly
          setCurrentStep(ASSESSMENT_STEPS.RESULTS);

          // Call onComplete callback if provided
          if (onComplete) {
            onComplete(responseData.assessment || responseData);
          }
        }
      } else {
        // Handle different error scenarios
        const errorData = response.error || response.payload?.error || response.payload;


        if (errorData?.code === 'MONTHLY_LIMIT_EXCEEDED') {
          // User already has account and reached monthly limit - show login prompt
          setCurrentStep(ASSESSMENT_STEPS.LOGIN_PROMPT);
        } else {

          // Handle specific registration errors
          let errorMessage = 'Gagal menyimpan data. Silakan coba lagi.';
          if (errorData?.message) {
            if (errorData.message.includes('email') && errorData.message.includes('sudah digunakan')) {
              errorMessage = 'Email sudah digunakan. Silakan gunakan email lain atau masuk ke akun yang sudah ada.';
            } else if (errorData.message.includes('phone') && errorData.message.includes('sudah digunakan')) {
              errorMessage = 'Nomor handphone sudah digunakan. Silakan gunakan nomor lain atau masuk ke akun yang sudah ada.';
            } else if (errorData.message.includes('sudah digunakan')) {
              errorMessage = 'Email atau nomor handphone sudah digunakan. Silakan gunakan data lain atau masuk ke akun yang sudah ada.';
            } else {
              errorMessage = errorData.message;
            }
          }

          setRegistrationError(errorMessage);
          return;
        }
      }
    } catch (error) {
      console.error('Registration error:', error);
      let errorMessage = 'Gagal menyimpan data. Silakan coba lagi.';
      if (error.message && error.message.includes('sudah digunakan')) {
        errorMessage = 'Email atau nomor handphone sudah digunakan. Silakan gunakan data lain atau masuk ke akun yang sudah ada.';
      }
      setRegistrationError(errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  // React Query for assessment data - similar to AssessmentHistoryDetail.jsx
  const {
    data: latestAssessmentResponse,
    isLoading: isLatestAssessmentLoading,
    error: latestAssessmentError,
    refetch: refetchLatestAssessment,
  } = useQuery({
    queryKey: ['latestAssessment'],
    queryFn: async () => {
      const response = await SERVICE_AI_ASSESSMENT.getLatestAssessment();
      return response;
    },
    staleTime: 2 * 60 * 1000, // 2 minutes
    cacheTime: 5 * 60 * 1000, // 5 minutes
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    retry: (failureCount, error) => {
      if (error.message?.includes('404') || error.message?.includes('ASSESSMENT_NOT_FOUND')) {
        return false;
      }
      return failureCount < 3;
    },
    enabled: loggedIn && (currentStep === ASSESSMENT_STEPS.RESULTS || hasMonthlyAssessment),
  });

  // Update state when React Query data changes
  useEffect(() => {
    if (latestAssessmentResponse?.success) {
      const responseData = latestAssessmentResponse.data || latestAssessmentResponse.payload;
      if (responseData?.assessment) {
        const updatedAssessment = responseData.assessment;
        setLatestAssessment(updatedAssessment);

        // Update existing feedback
        if (updatedAssessment.feedback) {
          setExistingFeedback(updatedAssessment.feedback);
        }

        if (updatedAssessment.bundle || updatedAssessment.recommendations) {
          const updatedRecommendations = {
            analysis: updatedAssessment.analysis || {},
            recommendations: updatedAssessment.recommendations || [],
            bundle: updatedAssessment.bundle || {},
            bundle_pricing: updatedAssessment.bundle_pricing || {},
            nextSteps: updatedAssessment.nextSteps || [],
            personal_learning_path: updatedAssessment.personal_learning_path || null,
            mentoring: updatedAssessment.mentoring || null,
          };
          setRecommendations(updatedRecommendations);
        }
      }
    }
  }, [latestAssessmentResponse]);

  // Load saved assessment and check for existing monthly assessment on mount
  // Preload all quiz images on component mount
  useEffect(() => {
    const imagesToPreload = [learnImg, currentImg, problemImg, skillImg];
    imagesToPreload.forEach(src => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const initializeAssessment = async () => {
      setIsInitializing(true);
      try {
        // Only check for monthly assessment if user is logged in
        if (loggedIn) {
          // First, check if user has a monthly assessment
          const latestResponse = await SERVICE_AI_ASSESSMENT.getLatestAssessment();

          const latestResponseData = latestResponse.data || latestResponse.payload;
          if (latestResponse.success && latestResponseData) {
            const { has_monthly_assessment, assessment, can_create_new } = latestResponseData;

            setCanCreateNew(can_create_new);

            if (has_monthly_assessment && assessment) {
              // User has existing assessment this month
              setHasMonthlyAssessment(true);
              setLatestAssessment(assessment);

              // Set existing feedback if available
              if (assessment.feedback) {
                setExistingFeedback(assessment.feedback);
              }

              // Show results if assessment is completed
              if (assessment.status === 'completed' && assessment.recommendations) {
                const existingRecommendations = {
                  recommendations: assessment.recommendations || [],
                  analysis: assessment.analysis || {},
                  bundle: assessment.bundle || {},
                  bundle_pricing: assessment.bundle_pricing || {},
                  nextSteps: assessment.nextSteps || [],
                  personal_learning_path: assessment.personal_learning_path || null,
                  mentoring: assessment.mentoring || null,
                };

                setRecommendations(existingRecommendations);
                setCurrentStep(ASSESSMENT_STEPS.RESULTS);
              }
            } else {
              // No monthly assessment, proceed with normal flow
              setHasMonthlyAssessment(false);

              // Try to load saved assessment from localStorage
              const savedAssessmentId = localStorage.getItem('currentAssessmentId');
              const savedModel = localStorage.getItem('selectedAiModel');

              if (savedModel) {
                setSelectedModel(savedModel);
              }

              if (savedAssessmentId) {
                try {
                  const response = await SERVICE_AI_ASSESSMENT.loadAssessment(savedAssessmentId);
                  const responseData = response.data || response.payload;
                  if (response.success && responseData) {
                    setAssessmentData(responseData.questions || responseData);
                    setAssessmentId(responseData.assessmentId || savedAssessmentId);
                    setAnswers(responseData.answers || {});
                    setCurrentStep(responseData.currentStep || 1);
                  }
                } catch (error) {
                  console.error('Failed to load saved assessment:', error);
                  // Clear invalid saved data
                  localStorage.removeItem('currentAssessmentId');
                  localStorage.removeItem('selectedAiModel');
                  // Don't show error to user for this as it's not critical
                }
              }
            }
          }
        } else {
          // User not logged in, proceed with normal guest flow
          setHasMonthlyAssessment(false);

          // Try to load saved assessment from localStorage for guest users
          const savedAssessmentId = localStorage.getItem('currentAssessmentId');
          const savedModel = localStorage.getItem('selectedAiModel');

          if (savedModel) {
            setSelectedModel(savedModel);
          }

          // For guest users, don't try to load from API since it requires authentication
          // They will start fresh each time or use static questions
          if (savedAssessmentId) {
            // Clear saved data for guest users since API calls won't work
            localStorage.removeItem('currentAssessmentId');
            localStorage.removeItem('selectedAiModel');
          }
        }
      } catch (error) {
        handleError(error, 'Gagal memuat data assessment. Mencoba dengan flow normal.');
        // Continue with normal flow if API fails
        setHasMonthlyAssessment(false);
      } finally {
        setIsInitializing(false);
      }
    };

    initializeAssessment();

    // Save UTM parameters when component loads
    HELPERS.saveUTMParameters();
    const utmParams = HELPERS.getUTMParameters();

    // Track assessment page load
    HELPERS.sendEventGA('assessment_page_load', {
      page_source: 'Business Assessment',
      page_path: '/personal-learning-program/quiz',
      user_status: loggedIn ? 'logged_in' : 'guest',
      ...utmParams
    });

    ReactPixel.track('ViewContent', {
      content_name: 'Assessment Page',
      content_category: 'personal_learning_assessment',
      content_type: 'assessment_page',
      ...utmParams
    });
  }, [loggedIn]);

  const renderContent = () => {
    const categoryIndex = currentStep - 1;

    // Show error state if there's an error
    if (error && !isLoading && !isSubmitting) {
      return (
        <div className="text-center p-8 flex flex-col items-center justify-center min-h-[500px]">
          <div className="text-red-500 mb-4">
            <svg className="w-16 h-16 mx-auto mb-4" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
            </svg>
          </div>
          <h2 className="text-xl font-semibold text-gray-800 mb-2">Terjadi Kesalahan</h2>
          <p className="text-gray-600 mb-6 max-w-md">
            {error || 'Terjadi kesalahan tidak terduga. Silakan coba lagi atau hubungi support.'}
          </p>
          <div className="quiz-buttons-container">
            <Button
              onClick={() => {
                setError(null);
                window.location.reload();
              }}
              variant={Button.VARIANTS.SECONDARY}
              size={Button.SIZES.MEDIUM}
              type="button"
            >
              Muat Ulang Halaman
            </Button>
            <Button
              onClick={() => {
                resetAssessmentState();
              }}
              variant={Button.VARIANTS.PRIMARY}
              size={Button.SIZES.MEDIUM}
              type="button"
            >
              Reset Assessment
            </Button>
          </div>
        </div>
      );
    }

    // Show loading while initializing
    if (isInitializing) {
      return <LoadingStep message="Menyiapkan quiz personal untuk bisnismu..." />;
    }

    if (currentStep === ASSESSMENT_STEPS.PERSONAL_INTRO) {
      return (
        <PersonalIntroStep
          onNext={handleGenerateQuestions}
          onBack={() => setCurrentStep(ASSESSMENT_STEPS.WELCOME)}
          isLoading={isLoading}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
        />
      );
    }

    if (currentStep === ASSESSMENT_STEPS.WELCOME) {
      return (
        <WelcomeStep
          onNext={handleGenerateQuestions}
          isLoading={isLoading}
          hasMonthlyAssessment={hasMonthlyAssessment}
          latestAssessment={latestAssessment}
          onViewResults={handleViewResults}
        />
      );
    }

    if (currentStep === ASSESSMENT_STEPS.LOGIN_PROMPT) {
      return (
        <LoginPromptStep
          onLogin={handleLoginRedirect}
          onBack={() => setCurrentStep(ASSESSMENT_STEPS.REGISTRATION_FORM)}
        />
      );
    }

    if (currentStep === ASSESSMENT_STEPS.REGISTRATION_FORM) {
      return (
        <RegistrationFormStep
          onSubmit={handleRegistrationSubmit}
          onBack={() => setCurrentStep(totalQuestionSteps)}
          isLoading={isSubmitting}
          userInfo={userInfo}
          setUserInfo={setUserInfo}
          apiError={registrationError}
          onClearError={() => setRegistrationError('')}
        />
      );
    }

    if (isLoading) {
      return (
        <LoadingStep message="Menyiapkan pertanyaan personal untuk Anda... (ini mungkin membutuhkan 30-60 detik)" />
      );
    }

    if (isSubmitting) {
      return <LoadingStep message="Sedang menganalisis potensi bisnismu... ✨" />;
    }

    if (isInQuestionPhase && assessmentData) {
      return (
        <QuestionStep
          category={assessmentData.categories[categoryIndex]}
          onNext={handleNext}
          onBack={handleBack}
          answers={answers}
          setAnswers={setAnswers}
          currentCategoryIndex={categoryIndex}
          totalCategories={totalQuestionSteps}
          isLoading={isLoading}
          isSubmitting={isSubmitting}
        />
      );
    }

    // Fallback to welcome
    return (
      <WelcomeStep
        onNext={handleGenerateQuestions}
        isLoading={isLoading}
        hasMonthlyAssessment={hasMonthlyAssessment}
        latestAssessment={latestAssessment}
        onViewResults={handleViewResults}
      />
    );
  };

  const getProgress = () => {
    if (currentStep === ASSESSMENT_STEPS.WELCOME) return 1;
    if (isInQuestionPhase) {
      return currentStep + 1; // Question pages start from step 2
    }
    return 1;
  };

  const getTotalProgressSteps = () => {
    return totalQuestionSteps + 1; // Include welcome in total
  };

  const showProgress = isInQuestionPhase && totalQuestionSteps > 0;

  if (shouldShowResults && recommendations) {
    return (
      <AssessmentResults
        recommendations={recommendations}
        onStartOver={handleStartOver}
        canCreateNew={canCreateNew}
        onGenerateNew={handleGenerateNew}
        isGenerating={isGeneratingNew}
        assessmentId={latestAssessment?.assessment_id || assessmentId}
        existingFeedback={existingFeedback}
        onFeedbackSubmitted={handleFeedbackSubmitted}
      />
    );
  }

  if (showResults && resultsData) {
    return (
      <AssessmentResults
        recommendations={resultsData}
        onStartOver={handleStartOver}
        canCreateNew={canCreateNew}
        onGenerateNew={handleGenerateNew}
        isGenerating={isGeneratingNew}
        assessmentId={assessmentId}
        existingFeedback={existingFeedback}
        onFeedbackSubmitted={handleFeedbackSubmitted}
      />
    );
  }

  if (isGuest && overlayEnabled) {
    return (
      <FullscreenOverlay
        lockScroll
        closeOnBackdropClick={false}
        closeOnEsc
        backdropClassName="bg-white"
        zIndex={9999}
        aria-label="Business Assessment Guest Overlay"
        onClose={dismissOverlay}
        showClose={!showProgress}
      >
        <div className="w-full h-full flex flex-col">
          {showProgress && (
            <div className="sticky top-0 w-full bg-white/90 backdrop-blur-sm z-10 px-4 py-2 md:py-3 border-b">
              <ProgressIndicator
                currentStep={getProgress()}
                totalSteps={getTotalProgressSteps()}
              />
            </div>
          )}

          <div className="flex-1 overflow-y-auto overflow-x-hidden">
            <div className="min-h-full flex items-center justify-center p-4">
              <div className="w-full max-w-3xl mx-auto">
                <div className="bg-white rounded-xl">
                  <div className="natural-transition-container">
                    {renderContent()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </FullscreenOverlay>
    );
  }
  return (
    <div className="bg-gray-50 pb-6 md:pb-12 flex items-center justify-center p-4">
      <div className="w-full max-w-3xl">
        {showProgress && <ProgressIndicator currentStep={getProgress()} totalSteps={getTotalProgressSteps()} />}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <div className="natural-transition-container">
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessAssessment;
